import React from 'react';
import { PageTitle } from 'modules/shared-ui/components';

import { formatDate } from 'modules/shared/utils';
import { AppointmentHistoryProps } from './appointment-history-type';

import styles from './appointment-history-component.module.css';

export const AppointmentHistory: React.FC<AppointmentHistoryProps> = ({
    pastAppointments,
}: AppointmentHistoryProps) => {
    return (
        <React.Fragment>
            <div className={styles.rootContainer}>
                <PageTitle title="MES PRÉCÉDENTS RENDEZ-VOUS" uppercase centered />

                {pastAppointments.length > 0 ? (
                    pastAppointments.map(appt => (
                        <div>{`${formatDate(appt.date)} - ${appt.type} à ${appt.location}`}</div>
                    ))
                ) : (
                    <div>Pas de précédents RDV.</div>
                )}
            </div>
        </React.Fragment>
    );
};
